import { useMemo } from "react";

import * as QueryRepository from "@/components/features/items/discount/item/multi/edit/model/repository/query";

import * as Converter from "./converter";
import * as DiscountItemMultiShared from "../../../../_shared";
import { useEditDiscountMultiFormModel } from "../../model";
import { useUpdateDiscountMulti } from "../use-update-discount-multi";

import type * as FormModelType from "../../type";

export const useInitialized = (hotelID: string, discountID: string) => {
	const { discountMultiForMultiServerModel } = QueryRepository.useDiscountMultiForMultiQuery(hotelID, discountID);

	const initInputModel: DiscountItemMultiShared.Model.ModelType.DiscountMultiFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter(hotelID, discountMultiForMultiServerModel),
		[discountMultiForMultiServerModel, hotelID],
	);

	const queryData = useMemo((): FormModelType.QueryData => {
		return {
			discountMulti: discountMultiForMultiServerModel?.discountMulti,
			discountOrdinary: discountMultiForMultiServerModel?.discountList?.ordinary ?? [],
			discountLongTerm: discountMultiForMultiServerModel?.discountList?.longTerm ?? [],
		} satisfies FormModelType.QueryData;
	}, [
		discountMultiForMultiServerModel?.discountList?.longTerm,
		discountMultiForMultiServerModel?.discountList?.ordinary,
		discountMultiForMultiServerModel?.discountMulti,
	]);

	const { inputModel, viewModel, onSetViewModel, onResetViewModel } = useEditDiscountMultiFormModel(initInputModel);

	const {
		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,

		// 適用ディスカウント
		// 適用ディスカウントの追加
		onAddMultiDiscounts,
		// 適用ディスカウントの変更
		onChangeMultiDiscounts,
		// 適用ディスカウントの削除
		onDeleteMultiDiscounts,

		// 追加設定
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
	} = DiscountItemMultiShared.Model.UseCase.useActions(viewModel, onSetViewModel);
	const { onUpdateDiscountMulti } = useUpdateDiscountMulti({ inputModel, onResetViewModel });

	return {
		//
		queryData,
		viewModel,
		// mutation
		onUpdateDiscountMulti,

		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,

		// 適用ディスカウント
		// 適用ディスカウントの追加
		onAddMultiDiscounts,
		onChangeMultiDiscounts,
		// 適用ディスカウントの削除
		onDeleteMultiDiscounts,

		// 追加設定
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
	};
};
